import React from 'react';

export default function LeftSide(props: React.PropsWithChildren<{}>) {
    return (
        <div className="col-md-4">
            <div className="sticky-top">{props.children}</div>
        </div>
    );
}
